import { Pipe, PipeTransform } from '@angular/core';
import { ContractorScopesDto } from '@artemis-software/wr-api';
import ContractorScopesEnum = ContractorScopesDto.ScopesEnum;

@Pipe({
  standalone: false,
  name: 'contractorScope',
})
export class ContractorScopePipe implements PipeTransform {
  transform(value: ContractorScopesEnum): string {
    switch (value) {
      case ContractorScopesEnum.BuildingBaseData:
        return 'Gebäude Basisdaten';
      case ContractorScopesEnum.BuildingInspections:
        return 'Gebäude Rundgänge';
      case ContractorScopesEnum.BuildingScans:
        return 'Gebäude Scans';
      case ContractorScopesEnum.BuildingSensors:
        return 'EOC';
      case ContractorScopesEnum.BuildingDocuments:
        return 'Gebäude Dokumente';
      case ContractorScopesEnum.BuildingTgas:
        return 'Gebäude TGA';
      case ContractorScopesEnum.BuildingEquipmentDocuments:
        return 'TGA Ordner';
    }
    return 'NAN';
  }
}
